import { render } from "./channelDetailByUser.vue?vue&type=template&id=f6393d7a&scoped=true"
import script from "./channelDetailByUser.vue?vue&type=script&lang=js"
export * from "./channelDetailByUser.vue?vue&type=script&lang=js"

import "./channelDetailByUser.vue?vue&type=style&index=0&id=f6393d7a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6393d7a"],['__file',"src/views/channel/components/channelDetailByUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6393d7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6393d7a', __exports__)) {
    console.log('reload')
    api.reload('f6393d7a', __exports__)
  }
  
  module.hot.accept("./channelDetailByUser.vue?vue&type=template&id=f6393d7a&scoped=true", () => {
    console.log('re-render')
    api.rerender('f6393d7a', render)
  })

}


export default __exports__